import React from 'react';
// import logo from './logo.svg';
import './App.css';
import HomePage from './components/pages/HomePage/HomePage';

const App = () => (<HomePage />);

export default App;



// WEBPACK FOOTER //
// ./src/App.js